import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
import { Loading, ErrorBoundary } from './components/ui';
import { SiteVisibilityProvider, PageVisibilityRoute } from './contexts/SiteVisibilityContext';
import { CookieConsentProvider } from './contexts/CookieConsentContext';

const PublicLayout = lazy(() => import('./components/layout/PublicLayout'));
const HomePage = lazy(() => import('./pages/HomePage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const PortfolioPage = lazy(() => import('./pages/PortfolioPage'));
const ProjectDetailPage = lazy(() => import('./pages/ProjectDetailPage'));
const ServicesPage = lazy(() => import('./pages/ServicesPage'));
const CareersPage = lazy(() => import('./pages/CareersPage'));
const JobDetailPage = lazy(() => import('./pages/JobDetailPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const LegalPage = lazy(() => import('./pages/LegalPage'));
const FaqPage = lazy(() => import('./pages/FaqPage'));
const QuotePage = lazy(() => import('./pages/QuotePage'));
const NewsPage = lazy(() => import('./pages/NewsPage'));
//const ArticlePage = lazy(() => import('./pages/ArticlePage'));

function App() {
  return (
    <SiteVisibilityProvider>
      <CookieConsentProvider>
        <BrowserRouter>
          <ErrorBoundary>
            <Suspense fallback={<Loading />}>
              <Routes>
                <Route path="/" element={<PublicLayout />}>
                <Route index element={<HomePage />} />
                <Route
                  path="about"
                  element={
                    <PageVisibilityRoute pageFlag="showAboutPage">
                      <AboutPage />
                    </PageVisibilityRoute>
                  }
                />
                <Route
                  path="portfolio"
                  element={
                    <PageVisibilityRoute pageFlag="showPortfolioPage">
                      <PortfolioPage />
                    </PageVisibilityRoute>
                  }
                />
                <Route
                  path="portfolio/:projectId"
                  element={
                    <PageVisibilityRoute pageFlag="showPortfolioPage">
                      <ProjectDetailPage />
                    </PageVisibilityRoute>
                  }
                />
                <Route
                  path="services"
                  element={
                    <PageVisibilityRoute pageFlag="showServicesPage">
                      <ServicesPage />
                    </PageVisibilityRoute>
                  }
                />
                <Route
                  path="careers"
                  element={
                    <PageVisibilityRoute pageFlag="showCareersPage">
                      <CareersPage />
                    </PageVisibilityRoute>
                  }
                />
                <Route
                  path="careers/:jobId"
                  element={
                    <PageVisibilityRoute pageFlag="showCareersPage">
                      <JobDetailPage />
                    </PageVisibilityRoute>
                  }
                />
                <Route
                  path="news"
                  element={
                    <PageVisibilityRoute pageFlag="showNewsPage">
                      <NewsPage />
                    </PageVisibilityRoute>
                  }
                />
                
                <Route
                  path="contact"
                  element={
                    <PageVisibilityRoute pageFlag="showContactPage">
                      <ContactPage />
                    </PageVisibilityRoute>
                  }
                />
                <Route
                  path="faq"
                  element={
                    <PageVisibilityRoute pageFlag="showFaqPage">
                      <FaqPage />
                    </PageVisibilityRoute>
                  }
                />
                <Route
                  path="quote"
                  element={
                    <PageVisibilityRoute pageFlag="showQuotePage">
                      <QuotePage />
                    </PageVisibilityRoute>
                  }
                />
                <Route
                  path="legal"
                  element={
                    <PageVisibilityRoute pageFlag="showLegalPage">
                      <LegalPage />
                    </PageVisibilityRoute>
                  }
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </Suspense>
        </ErrorBoundary>
      </BrowserRouter>
    </CookieConsentProvider>
  </SiteVisibilityProvider>
  );
}

export default App;
